import { combineReducers } from "redux";
import quizContactUs from "../features/admin/quizContactUs/Slice";

const quizContactus = combineReducers({
  quizContactUs: quizContactUs,
});

export default quizContactus;
